export const clientsReportConstants = {
	EXPORT_DATA: 'EXPORT_DATA',
	DOWNLOAD_DATA: 'DOWNLOAD_DATA'
}
